import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/redux/AuthSlice";
import accountReducer from "../features/dashboard/redux/accountSlice";
export const store = configureStore({
  reducer: { auth: authReducer, account: accountReducer },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
